import React from 'react'
import {render} from 'react-dom'
import {CssVarsProvider, extendTheme} from "@mui/joy/styles";
import App from './App'


const qazpostTheme = extendTheme({
    shadow: {
        xs: undefined,
        sm: undefined,
        md: undefined,
        lg: undefined,
        xl: undefined,
    },
    colorSchemes: {
        light: {
            palette: {
                primary: {
                    solidBg: '#355DEE',
                    solidHoverBg: '#3054D6',
                    softBg: '#EDF1FF',
                    softColor: '#355DEE',
                    softHoverBg: '#DDE5FF',
                }
            }
        }
    }
});


render(
    <CssVarsProvider theme={qazpostTheme}>
        <App/>
    </CssVarsProvider>,
    document.querySelector('#root')
)

